module.exports = __webpack_public_path__ + "static/img/s02.9442603d.png";